import graphql__ee1dfa247a95a97808e7 from "./__generated__/GridContribution_contribution.graphql.js";import { useRef } from "react";
import { useFragment, graphql } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";
import { uniqueId } from "lodash";

import ReactableMeasures from "./ReactableMeasures";
import BannerImage from "./BannerImage";
import ContributionTheme from "./ContributionTheme";
import ButtonLink from "../../Buttons/ButtonLink";
import Tooltip from "../../Tooltip/Tooltip";
import Icon from "../../Utils/Icon";
import { useFormatMessage } from "../../Intl/Context";
import { useRoutesContext } from "../../Routes/RoutesContext";

const GridContribution = props => {
  const contribution = useFragment(GridContribution_contribution, props.contribution);

  const contributionRef = useRef(uniqueId("contribution-"));
  const contributionId = contributionRef.current;

  const t = useFormatMessage();
  const showContribution = t(intlMessages.showContribution);
  const laureateContribution = t(intlMessages.laureateContribution);

  const { title, slug, theme, isFeatured, participativeModule } = contribution;
  const { slug: participativeModuleSlug, visualization } = participativeModule;
  const bannerImageUrl = visualization?.bannerImageUrl;

  const { pathFor } = useRoutesContext();
  const showContributionUrl = pathFor("contribution", {
    participativeModuleSlug,
    contributionSlug: slug
  });

  const className = classNames([
    "col-md-4",
    "card-flex-wrapper",
    "contribution-grid-tile",
    props.className
  ]);

  return (
    <div className={className}>
      <div className="card box box-shadow">
        {isFeatured && (
          <div className="margin-bottom-xs height-md one-line d-flex">
            <Tooltip content={laureateContribution}>
              <div className="d-flex box margin-right-xs justify-content-center align-items-center padding-x-md">
                <Icon className="fa fa-trophy text-primary text-number-lg" />
              </div>
            </Tooltip>

            <ReactableMeasures
              reactable={contribution}
              className="box flex-1 box-expanded justify-content-center"
            />
          </div>
        )}

        <h3
          id={contributionId}
          className="card-header margin-bottom-xs text-title-overview padding-sm"
        >
          {title}
        </h3>

        {theme && (
          <ContributionTheme className="card-img-bottom margin-bottom-xs" theme={theme} />
        )}

        {!theme && bannerImageUrl && (
          <BannerImage
            url={bannerImageUrl}
            className="card-img-bottom margin-bottom-xs"
          />
        )}

        {!isFeatured && (
          <ReactableMeasures
            reactable={contribution}
            className="box justify-content-center margin-bottom-xs height-md one-line"
          />
        )}

        <ButtonLink
          href={showContributionUrl}
          className="contribution-show-btn btn btn-primary btn-block-md card-footer"
          label={showContribution}
          iconClassName="icon-arrow-right"
          iconPosition="after"
          aria-describedby={contributionId}
          data-contribution-show-button
        />
      </div>
    </div>
  );
};

const GridContribution_contribution = graphql__ee1dfa247a95a97808e7;

export default GridContribution;

const intlMessages = defineMessages({
  showContribution: {
    id: "contribution.preview.showContribution",
    defaultMessage: "Consulter"
  },
  laureateContribution: {
    id: "contribution.preview.laureateContribution",
    defaultMessage: "Cette proposition est lauréate de l'appel à projets"
  }
});
